<template>
  <JbTaskDetail :biz-ctg="$config.BIZ_CATEGORY.FIRE" ref="task" @link="handleLink" />
</template>
<script>
import JbTaskDetail from '@/views/omp/cleaning/task/components/JbTaskDetail.vue'
export default {
  name: "FireTaskDetail"
  , components: {
    JbTaskDetail
  }
  , data() {
    return {
    }
  }
  , compute: {}
  , methods: {
    handleLink(data) {
      let workOrderId = this.$route.params.id
      let { operationId, operationIdVersion } = data
      this.$router.push({ path: `/omp/fire/task/${workOrderId}/view`, query: { workOrderId, operationId, operationIdVersion } })
    }
  }
}
</script>
